import { create } from 'zustand';

export type UseTableCheckStore = {
  ids: string[];
};

const defaultValue: UseTableCheckStore = {
  ids: [],
};

export const useTableCheckStore = create<UseTableCheckStore>(() => ({
  ...defaultValue,
}));

export const useTableCheckIds = () => useTableCheckStore((state) => state.ids);

export const useTableCheck = () => useTableCheckStore((state) => state);

export const changeTableCheckIds = (ids: string[]) =>
  useTableCheckStore.setState({ ids });
